import Vue from 'vue'
import Router from 'vue-router'

import InvoiceReceive from '@/components/invoice/InvoiceReceive'
import ReceiveHistory from '@/components/invoice/InvoiceReceiveHistory'
import InvoiceUnSettled from '@/components/invoice/InvoiceUnSettled'
import InvoiceDelete from '@/components/invoice/InvoiceDelete'
import FailedInvoicing from '@/components/invoice/FailedInvoicing'

import KontraCreate from '@/components/kontra/KontraCreate'
import KontraReceived from '@/components/kontra/KontraReceived'
import KontraPrint from '@/components/kontra/KontraPrint'
import KontraRePrint from '@/components/kontra/KontraRePrint'
import KontraIsPrint from '@/components/kontra/KontraIsPrint'
import pdfKontraRePrint from '@/components/kontra/pdfKontraRePrint'

import PendingFunds from '@/components/receivable/PendingFunds'
import ReceivableHotList from '@/components/receivable/ReceivableHotList'
import ReceivableList from '@/components/receivable/ReceivableList'
import ReceivableCutOffList from '@/components/receivable/ReceivableCutOffList'
import ReceivableListDetail from '@/components/receivable/ReceivableListDetail'
import ReceivableDelete from '@/components/receivable/ReceivableDelete'
import ReceivableAddList from '@/components/receivable/ReceivableAddList'
import ReceivableDepositCreate from '@/components/receivable/ReceivableDepositCreate'
import ReceivableDepositList from '@/components/receivable/ReceivableDepositList'
import MutationDepositList from '@/components/receivable/MutationDepositList'
import ReceivableWithdrawalHistory from '@/components/receivable/ReceivableWithdrawalHistory'
import AdministratorReceivableDelete from '@/components/receivable/AdministratorReceivableDelete'

import PaymentList from '@/components/payment/PaymentList'
import PaymentAdd from '@/components/payment/PaymentAdd'
import PaymentAdjustment from '@/components/payment/PaymentAdjustment'
import PaymentDelete from '@/components/payment/PaymentDelete'
import PaymentPendingList from '@/components/payment/PaymentPendingList'
import PaymentPendingListData from '@/components/payment/PaymentPendingListData'
import PaymentDiscountList from '@/components/payment/PaymentDiscountList'
import PaymentPendingAssign from '@/components/payment/PaymentPendingAssign'
import PaymentPendingAdd from '@/components/payment/PaymentPendingAdd'
import PaymentDeleteHistory from '@/components/payment/PaymentDeleteHistory'
import PaymentPendingDownload from '@/components/payment/PaymentPendingDownload'
import PaymentTransactionNoteNew from '@/components/payment/PaymentTransactionNoteNew'
import PaymentTransactionNote from '@/components/payment/PaymentTransactionNote'
import PaymentTransactionNoteGiro from '@/components/payment/PaymentTransactionNoteGiro'
import PaymentTransactionNoteAdjustment from '@/components/payment/PaymentTransactionNoteAdjustment'
import AdjustmentNoteCode from '@/components/payment/AdjustmentNoteCode'

import DepositAdd from '@/components/deposit/DepositAdd'

// import Role from '@/components/master/Role'
import User from '@/components/master/User'
import ItemDept from '@/components/master/ItemDept';
import MarkingGroup from '@/components/master/MarkingGroup';
import MarkingTop from '@/components/master/MarkingTop';
import BankAccount from '@/components/master/BankAccount'
import BankAccountGroup from '@/components/master/BankAccountGroup'
import Coa from '@/components/master/Coa';
import division from '@/components/master/Division';

// import SendSms from '@/components/sms/Send'
import LogSms from '@/components/sms/Log'

//New Bluetron and BRPrint
import Settings from '@/components/Settings'
import SuratJalan from '@/components/surat/SuratJalan'
import SuratJalanBelumPrint from '@/components/surat/SuratJalanBelumPrint'
import DashboardInvoices from '@/components/dashboard/DashboardInvoices'

import Claim from '@/components/claim/Claim'
import ClaimList from '@/components/claim/ClaimList'
import ClaimDownload from '@/components/claim/ClaimDownload'
import ClaimPaymentAdd from '@/components/claim/ClaimPaymentAdd'
import ClaimTransactionNote from '@/components/claim/ClaimTransactionNote'

import Giro from '@/components/giro/Giro'
import GiroList from '@/components/giro/GiroList'
import GiroPending from '@/components/giro/GiroPending'
import GiroCalendar from '@/components/giro/GiroCalendar'
import GiroDueDate from '@/components/giro/GiroDueDate'
import GiroPaymentAdd from '@/components/giro/GiroPaymentAdd'
import GiroCancelledHistory from '@/components/giro/GiroCancelledHistory'
import GiroTransactionNote from '@/components/giro/GiroTransactionNote'

import LogERPJournalPooling from '@/components/logs/ERPJournalPooling'

import OmsetAdd from '@/components/omset/OmsetAdd'
import OmsetList from '@/components/omset/OmsetList'

import locale from 'iview/src/locale/lang/en-US';

import iView from 'iview';
import 'iview/dist/styles/iview.css';




Vue.use(iView, { locale });
Vue.use(Router)

export default new Router({
  routes: [
    // { path: '/', redirect: '/kontra/create'},

    { path: '/invoice/receive', component: InvoiceReceive, meta: { title: 'Terima' } },
    { path: '/invoice/receiveHistory', component: ReceiveHistory, meta: { title: 'Histori' } },
    { path: '/invoice/delete', component: InvoiceDelete, meta: { title: 'Hapus Invoice' } },

    { path: '/invoice/invoiceUnSettled', component: InvoiceUnSettled, meta: { title: 'Jatuh Tempo' } },
    { path: '/invoice/failedInvoicing', component: FailedInvoicing, meta: { title: 'Failed Invoicing' } },

    { path: '/kontra/create', component: KontraCreate, meta: { title: 'Buat' } },
    { path: '/kontra/print', component: KontraPrint, meta: { title: 'Cetak' } },
    { path: '/kontra/reprint', component: KontraRePrint, meta: { title: 'Cetak Ulang' } },
    { path: '/kontra/received', component: KontraReceived },
    { path: '/kontra/pdfKontraRePrint', component: pdfKontraRePrint },

    //
    { path: '/administrator/kontra/isprint', component: KontraIsPrint, meta: { title: 'Kontra Print Status' } },
    { path: '/administrator/receivable/delete', component: AdministratorReceivableDelete, meta: { title: 'Hapus Piutang' } },

    { path: '/receivable/list', component: ReceivableList, meta: { title: 'Kartu Piutang History' } },
    { path: '/receivable/list/cut-off', component: ReceivableCutOffList, meta: { title: 'Kartu Piutang' } },
    { path: '/receivable/list-detail', component: ReceivableListDetail, meta: { title: 'Kartu Piutang Detail' } },
    { path: '/receivable/delete', component: ReceivableDelete, meta: { title: 'Hapus Piutang' } },

    { path: '/deposit/add', component: DepositAdd },

    // this use to pass "paymentPending" props to Payment Add Page
    // { path: '/payment/historyPayNoDetail', component: PaymentHistoryPayNoDetail },

    { path: '/payment/discount-list', component: PaymentDiscountList, meta: { title: 'Histori Potongan' } },
    { path: '/payment/list', component: PaymentList, meta: { title: 'Histori' } },
    { path: '/payment/add', component: PaymentAdd, meta: { title: 'Penyesuaian' } },
    { path: '/payment/adjustment', component: PaymentAdjustment, meta: { title: 'Penyesuaian Baru' } },
    { path: '/payment/pending/add', component: PaymentPendingAdd, name: 'paymentPendingAdd', props: true },
    { path: '/payment/pending/assign', component: PaymentPendingAssign, name: 'paymentPendingAssign', props: true },
    { path: '/payment/delete', component: PaymentDelete, meta: { title: 'Hapus' } },
    { path: '/payment/history/delete', component: PaymentDeleteHistory, meta: { title: 'Histori Hapus' } },
    { path: '/payment/paymentPending/list', component: PaymentPendingList },
    { path: '/payment/paymentPending/list-data/:type/:data', component: PaymentPendingListData, meta: { title: 'List Data' } },
    { path: '/payment/paymentPending/list-data/search/:dummy', component: PaymentPendingListData, meta: { title: 'List Data' } },
    { path: '/payment/download', component: PaymentPendingDownload, meta: { title: 'Download' } },

    { path: '/mutasi/create', component: PaymentTransactionNoteNew },
    { path: '/mutasi/list', component: PaymentTransactionNote, meta: { title: 'NT - Mutasi' } },
    { path: '/mutasi/list/giro', component: PaymentTransactionNoteGiro, meta: { title: 'NT - Giro' } },
    { path: '/mutasi/list/adjustment', component: PaymentTransactionNoteAdjustment, meta: { title: 'NT - Penyesuaian' } },
    { path: '/fix-note', component: AdjustmentNoteCode, meta: { title: 'Penyesuaian NT' } },

    { path: '/dashboard/invoices', component: DashboardInvoices, meta: { title: 'Invoices' } },

    // { path: '/master/role', component: Role },
    { path: '/master/user', component: User, meta: { title: 'User' } },
    { path: '/master/itemDept', component: ItemDept, meta: { title: 'Item Dept' } },
    { path: '/master/bankAccount', component: BankAccount, meta: { title: 'Bank Account' } },
    { path: '/master/bankAccountGroup', component: BankAccountGroup, meta: { title: 'Bank Account Group' } },
    { path: '/master/markingGroup', component: MarkingGroup, meta: { title: 'Marking Group' } },
    { path: '/master/marking-top', component: MarkingTop, meta: { title: 'Marking TOP' } },
    { path: '/master/coa', component: Coa, meta: { title: 'Chart of Account (COA)' } },
    { path: '/master/division', component: division, meta: { title: 'Division' } },

    // { path: '/sms/send', component: SendSms },
    { path: '/sms/log', component: LogSms, meta: { title: 'Log' } },

    { path: '/settings', component: Settings, meta: { title: 'Setting' } },
    { path: '/surat/suratjalan', component: SuratJalan, meta: { title: 'Surat Jalan' } },
    { path: '/surat/suratjalanbelumprint', component: SuratJalanBelumPrint, meta: { title: 'Surat Jalan Belum Di Print' } },

    { path: '/receivable/pendingFunds', component: PendingFunds, meta: { title: 'Tambah' } },
    { path: '/receivable/hotList', component: ReceivableHotList, meta: { title: 'Summary Kartu Piutang' } },
    { path: '/receivable/receivableAddList', component: ReceivableAddList, meta: { title: 'List Piutang Manual' } },

    //Deposit
    { path: '/deposit/create', component: ReceivableDepositCreate },
    { path: '/deposit-adjustment', component: ReceivableDepositList, meta: { title: 'Penyesuaian' } },
    { path: '/deposit-mutation', component: MutationDepositList, meta: { title: 'Mutation' } },
    { path: '/deposit/withdrawal-history', component: ReceivableWithdrawalHistory, meta: { title: 'Histori Penarikan' } },

    { path: '/claim/add', component: Claim, meta: { title: 'Tambah' } },
    { path: '/claim/list', component: ClaimList, meta: { title: 'List' } },
    { path: '/claim/download', component: ClaimDownload, meta: { title: 'Download' } },
    { path: '/claim/paymentAdd', component: ClaimPaymentAdd, name: 'claimPaymentAdd', props: true },
    { path: '/claim/transaction-note', component: ClaimTransactionNote, meta: { title: 'Nota Transaksi' } },

    // { path: '/giro', component: Giro},
    { path: '/giro/list', component: GiroList, meta: { title: 'List' } },
    { path: '/giro/calendar', component: GiroCalendar, meta: { title: 'Kalender' } },
    { path: '/giro/pending', component: GiroPending, meta: { title: 'Pending' } },
    { path: '/giro/dueDate', component: GiroDueDate, meta: { title: 'Jatuh Tempo' } },
    { path: '/giro/paymentAdd', component: GiroPaymentAdd, name: 'giroPaymentAdd', props: true },
    { path: '/giro/cancelled-history', component: GiroCancelledHistory, meta: { title: 'Histori Pembatalan' } },
    { path: '/giro/transaction-note', component: GiroTransactionNote, meta: { title: 'Nota Transaksi' } },

    { path: '/logs/erp/journal-pooling', component: LogERPJournalPooling, meta: { title: 'ERP Journal Pooling' } },

    { path: '/omset/add', component: OmsetAdd, meta: { title: 'Omset' } },
    { path: '/omset/list', component: OmsetList, meta: { title: 'Omset List' } },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js